const utmParamKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const entryFormPath = '/classic_entries/new';
const utmClearedFlagKey = 'utm_cleared';

const storeUtmParams = () => {
  const currentUrl = new URL(window.location.href);

  // 初回流入時のUTMを維持するため、保存済みのパラメータは上書きしない
  utmParamKeys.forEach((key) => {
    const value = currentUrl.searchParams.get(key);
    if (value && !sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, value);
      // 新しい流入とみなし、EFクリックによるクリア済み状態を解除する
      sessionStorage.removeItem(utmClearedFlagKey);
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  const currentUrl = new URL(window.location.href); // 現在のURLを取得
  const seoGroupParam = currentUrl.searchParams.get('seo_group'); // URLからseo_groupパラメータを取得

  // リファラーが存在し、異なるドメインの場合にセッションストレージを更新
  if (document.referrer) {
    const referrerUrl = new URL(document.referrer);
    const referrerUrlHostname = referrerUrl.hostname.toLowerCase();
    if (referrerUrlHostname !== currentUrl.hostname.toLowerCase()) {
      sessionStorage.setItem('seo_group', referrerUrlHostname);
      sessionStorage.removeItem(utmClearedFlagKey);
    }  // 同一ドメインの場合は何もしない
  } else if (seoGroupParam) {
    // リファラーがない場合はURLパラメータからseo_groupをセッションストレージに保存
    sessionStorage.setItem('seo_group', seoGroupParam);
    sessionStorage.removeItem(utmClearedFlagKey);
  }

  storeUtmParams();
});

// 'turbolinks:load'でページ遷移ごとにJSが発火
window.addEventListener('turbolinks:load', () => {
  storeUtmParams();

  // EFクリック後にクリア済みのときだけ、リンクに残る古いパラメータを積極的に消す。
  // 未クリアのときはsessionStorageに値がなくても、サーバーが埋め込んだ値を消さない
  // （sessionStorageはタブごとに独立しており、別タブ経由の初回アクセスでは空になり得るため）。
  const cleared = sessionStorage.getItem(utmClearedFlagKey) === 'true';

  document.querySelectorAll('a').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href || !href.includes(entryFormPath)) return;

    const newLink = new URL(href, window.location.origin);

    const seoGroup = sessionStorage.getItem('seo_group');
    if (seoGroup) {
      newLink.searchParams.set('seo_group', seoGroup);
    } else if (cleared) {
      newLink.searchParams.delete('seo_group');
    }

    utmParamKeys.forEach((key) => {
      const value = sessionStorage.getItem(key);
      if (value) {
        newLink.searchParams.set(key, value);
      } else if (cleared) {
        newLink.searchParams.delete(key);
      }
    });

    link.setAttribute('href', newLink.toString());
  });
});

// リンクごとにリスナーを付け替えるとTurbolinksのページキャッシュ復元時に
// リスナーだけが失われるため、documentへの委譲で1度だけ登録する
document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const target = event.target;
  const link = target && target.closest ? target.closest('a') : null;
  if (!link) return;
  if (link.target && link.target !== '_self') return;

  const href = link.getAttribute('href');
  if (!href || !href.includes(entryFormPath)) return;

  // リンククリック後にセッションストレージから情報を削除
  sessionStorage.removeItem('seo_group');
  utmParamKeys.forEach((key) => {
    sessionStorage.removeItem(key);
  });
  sessionStorage.setItem(utmClearedFlagKey, 'true');
});
